module.exports = __webpack_public_path__ + "img/fzlc-4.55c29dca.png";